var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PICLoadPage_modalFooter, _PICLoadPage_isDisabled, _PICLoadPage_modalBody, _PICLoadPage_cssElms, _PICLoadPage_settingsReadAlready;
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { property, query } from 'lit/decorators.js';
import { directive } from 'lit/directive.js';
import { LitElement, html, css, nothing } from 'lit';
import { stringDecoder, booleanDecoder, objectDecoder, InlineScriptDirective, customElement, PICInput, PICModal, doSubmit, PIC, PICWebTable, loadPage, fetchFormData, fetchWithFormData, PICAction, PICTab, Util, PICDualSelector } from '../Internals';
let PICLoadPage = class PICLoadPage extends LitElement {
    constructor() {
        super();
        this.header = '';
        this.events = [];
        this.apiurl = '';
        this.params = '';
        this.closeEvent = '';
        this.isVisible = false;
        this.systemId = undefined;
        this.isClosed = false;
        //set to True to prevent next render, used for #response.
        this.preventRender = false;
        this.isNew = false;
        this.isOldUploadModal = false;
        this.parentSessId = PIC.sessionCode;
        this.postBody = this.refreshPostBody();
        this.options = {
            // sessionId: this.sessionId,
            postBody: this.postBody,
        };
        this.submitInProgress = false;
        this.dataIsReady = false;
        this.htmlDoc = new DOMParser().parseFromString('<dummy/>', 'text/xml');
        this.isFirstLoad = true;
        this.modalHeader = null;
        _PICLoadPage_modalFooter.set(this, null);
        this.hasError = false;
        this.loadpageBroadcastChannel = new BroadcastChannel("loadpage");
        this.choices = [{ choiceText: 'ok', choiceEvent: '', chooseBtnFocus: false }];
        _PICLoadPage_isDisabled.set(this, false);
        _PICLoadPage_modalBody.set(this, void 0);
        _PICLoadPage_cssElms.set(this, void 0);
        _PICLoadPage_settingsReadAlready.set(this, false);
        this.overrideCloseEvent = false;
        this.parentFieldStr = '';
        /* This is where the functions from pic calls are definde internally to save memory instead of creating a new PIC object each time */
        this.listeners = new Map();
        this.timeouts = [];
        this.disableNav = false;
        this.allowResize = true;
        this.cssStrings = [];
        this.keepSize = false;
        this.centerOnParent = false;
    }
    performUpdate() {
        super.performUpdate();
    }
    shouldUpdate() {
        return this.lastResult !== 'command' && (this.isVisible && !this.preventRender && this.lastResult !== 'loadpage' || this.isClosed);
    }
    requestfileposter(url, body, sys) {
        var req = new XMLHttpRequest();
        if (!url) {
            url = window.location.href;
        }
        return new Promise(function (resolve, reject) {
            req.open('POST', url);
            req.responseType = 'blob';
            req.setRequestHeader('picsystem', sys);
            req.onload = function () {
                if (req.status == 200) {
                    resolve(req);
                }
                else {
                    reject(Error(req.statusText));
                }
            };
            req.onerror = function () {
                reject(Error('Network Error'));
            };
            req.send(body);
        });
    }
    clearAllProps() {
        this.parentSessId = undefined;
        this.selfSessId = undefined;
        this.clearTimeouts();
        this.clearEventListeners();
    }
    refreshPostBody() {
        var _a, _b;
        return this.postBody = {
            sessionid: this.selfSessId,
            parentSessId: (_a = this.parentSessId) !== null && _a !== void 0 ? _a : PIC.getInstance.sessionCode,
            prog2run: this.apiurl,
            params: this.params,
            sys: (_b = this.systemId) !== null && _b !== void 0 ? _b : PIC.systemId,
            __stylesheet: this.getStyleSheet(),
        };
    }
    getFormData(iEventId, iProg2Run, keepSession) {
        var _a, _b, _c, _d, _e, _f;
        let PICFieldList = [];
        let body = this.shadowRoot.querySelector('body');
        this.getPICInputFields(body, PICFieldList);
        let fieldMap = new Map(PICFieldList.map(e => { return [e.id, e]; }));
        let formElm = (_a = this.shadowRoot.getElementById('PICSubForm')) !== null && _a !== void 0 ? _a : document.PICForm;
        let queryParms = {
            'eventid': iEventId ? iEventId : 'load',
            'moduleId': 'modal',
            'Subwin': iProg2Run ? iProg2Run : this.apiurl,
            'loadpagedata': (_b = btoa(JSON.stringify(this.postBody))) !== null && _b !== void 0 ? _b : '',
            'SystemId': (_c = this.systemId) !== null && _c !== void 0 ? _c : PIC.systemId
        };
        //This will clean params after new has been called - oneshot
        if (!keepSession) {
            queryParms['SessionOption'] = 'new';
            let parmStr = this.params.split(',');
            // get the parentFieldStr from the parmStr
            this.parentFieldStr = (_e = (_d = parmStr.find(e => e.includes('parentField'))) === null || _d === void 0 ? void 0 : _d.split('=')[1]) !== null && _e !== void 0 ? _e : '';
            if (this.params !== 'commInfo')
                this.params = '';
            this.refreshPostBody();
        }
        queryParms['SessionCode'] = (_f = this.selfSessId) !== null && _f !== void 0 ? _f : PIC.getInstance.sessionCode;
        let tmpForm = fetchFormData.makePicQuery(false, formElm, fieldMap, queryParms);
        let formOf = typeof tmpForm === 'string' ? String(tmpForm) : '';
        return formOf;
    }
    compareTwo(a, b) {
        let aArr = a.split('\.');
        let bArr = b.split('\.');
        if (aArr.length === bArr.length) {
            return Number(bArr[bArr.length - 1]) - Number(aArr[aArr.length - 1]);
        }
    }
    checkOldVsNewSess(iParentSess, iSelfSess) {
        var _a;
        let oldParentSess = this.parentSessId;
        let oldSelfSess = (_a = this.selfSessId) !== null && _a !== void 0 ? _a : '';
        let parentLvl = this.compareTwo(oldParentSess !== null && oldParentSess !== void 0 ? oldParentSess : '', iParentSess);
        let selfLvl = this.compareTwo(oldSelfSess !== null && oldSelfSess !== void 0 ? oldSelfSess : '', iSelfSess);
        if (parentLvl === 0) {
            if ((selfLvl === 1 || selfLvl === -1) && PIC.getInstance.PICWinMap.has(oldSelfSess)) {
                PIC.getInstance.PICWinMap.delete(oldSelfSess);
            }
        }
    }
    getDataFromApi(iEventId, iProg2Run, keepSession) {
        //Modal query parms ('moduleId': 'modal')
        this.options = { formData: this.getFormData(iEventId, iProg2Run, keepSession) };
        this.isOldUploadModal = false;
        //If fromDate is empty then it is a Preventable 
        if (this.options.formData === '') {
            return Promise.resolve({});
        }
        return fetchWithFormData(this.options).then((data) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
            window.modalIsLoading = false;
            this.preventRender = false;
            if (!data) {
                this.dataIsReady = false;
                this.isVisible = false;
                let modal = this.slotParent;
                modal === null || modal === void 0 ? void 0 : modal.closeModal(false);
                this.clearAllProps();
            }
            try {
                data.webresponse = atob(data.webresponse);
                this.checkOldVsNewSess(data.parentSessionCode, data.sessionCode);
                this.parentSessId = data.parentSessionCode;
                this.selfSessId = data.sessionCode;
                if (this.selfSessId)
                    PIC.getInstance.PICWinMap.set(this.selfSessId, this);
                this.refreshPostBody();
                if (!keepSession) {
                    let msg = { command: 'DISABLE', sessionId: this.parentSessId };
                    this.loadpageBroadcastChannel.postMessage(msg);
                }
            }
            catch (_w) {
                if (data.ReturnInfo[0].MsgCode) {
                    switch (data.ReturnInfo[0].MsgCode) {
                        case '000':
                            console.log('Echo Ok');
                            break;
                        case '993':
                            console.log('Userid is closed');
                            break;
                        case '994':
                            console.log(data.ReturnInfo[0].MsgText);
                            break;
                        case '995':
                            console.log('Unknown Command');
                            break;
                        case '996':
                            console.log('Invalid Userid/Password');
                            doSubmit('#exit');
                            break;
                        case '997':
                            console.log('Bad OpCode/No OpCode');
                            break;
                        case '999':
                            console.log('Structure Error');
                            break;
                        default:
                            break;
                    }
                    this.lastResult = 'error';
                    this.dataIsReady = false;
                    this.isVisible = false;
                    let modal = this.slotParent;
                    modal === null || modal === void 0 ? void 0 : modal.closeModal(false);
                    this.clearAllProps();
                    return;
                }
            }
            let modal = this.slotParent;
            let parser = new DOMParser();
            if (data.webresponse.length == 0) {
                this.dataIsReady = true;
                this.isVisible = false;
                this.lastResult = 'close';
                modal === null || modal === void 0 ? void 0 : modal.closeModal(false);
                this.clearAllProps();
            }
            else if (data.webresponse.startsWith('doSubmit')) {
                this.isVisible = false;
                this.lastResult = 'doSubmit';
                modal === null || modal === void 0 ? void 0 : modal.closeModal(false);
                (_a = this.modal) === null || _a === void 0 ? void 0 : _a.closeModal(false);
                let submitStr = data.webresponse.replace('doSubmit', '');
                submitStr = submitStr.replace(/(\(|"|\)|')/gm, '');
                if (this.selfSessId && PIC.getInstance.PICWinMap.has(this.selfSessId)) {
                    this.handleSubmit(submitStr, null);
                }
                this.clearAllProps();
            }
            else if (data.webresponse.startsWith('#getans')) {
                let getAnsHtml = unescape(data.webresponse.split('#')[2]);
                let parser = new DOMParser();
                let getAnsDoc = parser.parseFromString(getAnsHtml, 'text/html');
                let getAnsDocEl = getAnsDoc.documentElement.querySelector('pic-getans');
                if (getAnsDocEl) {
                    getAnsHtml = (_b = getAnsDocEl === null || getAnsDocEl === void 0 ? void 0 : getAnsDocEl.innerHTML) !== null && _b !== void 0 ? _b : '';
                    let getAnsElement = document.querySelector('pic-getans#base-ans');
                    if (!getAnsElement) {
                        getAnsElement = document.createElement('pic-getans');
                        getAnsElement.isHidden = true;
                        getAnsElement.setAttribute('id', 'base-ans');
                        document.body.append(getAnsElement);
                    }
                    getAnsElement.innerHTML = ``;
                    getAnsElement.innerHTML = getAnsHtml;
                    getAnsElement.setAttribute('title', getAnsDocEl.title);
                    getAnsElement.isHidden = false;
                    try {
                        getAnsElement.parentId = this.selfSessId;
                    }
                    catch (_x) { }
                    let hiddenModal = (_c = getAnsElement.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('pic-modal');
                    if (hiddenModal && !hiddenModal.isHidden) {
                        window.addEventListener('keydown', hiddenModal.handleKeys);
                        // hiddenModal.blockBackground = true;
                    }
                }
                else {
                    //TODO display error box
                    console.log('Failed to open getAns box', getAnsHtml);
                }
            }
            else if (data.webresponse.startsWith('#ViewGallery')) {
                this.lastResult = 'gallery';
                let arr = data.webresponse.split(',');
                let curLine;
                let terminal;
                let value;
                let identifier;
                let user;
                let NoteId;
                for (let i = 0; i < arr.length; i++) {
                    curLine = (_d = arr[i]) !== null && _d !== void 0 ? _d : '';
                    if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('terminal')) {
                        terminal = (_e = curLine.split('=')[1]) !== null && _e !== void 0 ? _e : '';
                    }
                    else if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('value')) {
                        value = (_f = curLine.split('=')[1]) !== null && _f !== void 0 ? _f : '';
                    }
                    else if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('identifier')) {
                        identifier = (_g = curLine.split('=')[1]) !== null && _g !== void 0 ? _g : '';
                    }
                    else if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('user')) {
                        user = (_h = curLine.split('=')[1]) !== null && _h !== void 0 ? _h : '';
                    }
                    else if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('NoteId')) {
                        NoteId = (_j = curLine.split('=')[1]) !== null && _j !== void 0 ? _j : '';
                    }
                }
                //TODO: needs better handling, currently all the file logic is handled in showmessage on progress side
                this.handleSubmit(data.webresponse, null);
            }
            else if (data.webresponse.startsWith('#openPDF')) {
                this.lastResult = 'pdf';
                let arr = data.webresponse.split(',');
                let curLine;
                let iSys;
                let filename = '';
                let requestURI = '../mobile/getpdf.php?filename=';
                for (let i = 0; i < arr.length; i++) {
                    curLine = (_k = arr[i]) !== null && _k !== void 0 ? _k : '';
                    if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('iSys')) {
                        iSys = (_l = curLine.split('=')[1]) !== null && _l !== void 0 ? _l : '';
                    }
                    else {
                        filename = curLine;
                    }
                }
                requestURI += filename;
                return this.requestfileposter(requestURI, '', '').then((res) => {
                    let blob = res.response;
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.dataIsReady = true;
                });
            }
            else if (data.webresponse.startsWith('#OpenPrint')) {
                this.lastResult = 'print';
                let arr = data.webresponse.split(',');
                let inputfile = [];
                let tmpinputfile = [];
                let outputfile = [];
                let system = [];
                let curLine = '';
                let fileArray = [];
                for (let i = 0; i < arr.length; i++) {
                    curLine = (_m = arr[i]) !== null && _m !== void 0 ? _m : '';
                    if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('inputfile'))
                        inputfile.push((_o = curLine.split('=')[1]) !== null && _o !== void 0 ? _o : '');
                    else if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('outputfile'))
                        outputfile.push((_p = curLine.split('=')[1]) !== null && _p !== void 0 ? _p : '');
                    else if (curLine === null || curLine === void 0 ? void 0 : curLine.startsWith('system'))
                        system.push((_q = curLine.split('=')[1]) !== null && _q !== void 0 ? _q : '');
                }
                inputfile.forEach((fileList) => {
                    tmpinputfile = fileList.split('^');
                    tmpinputfile.forEach((file, index) => {
                        if (outputfile[index] === undefined)
                            outputfile[index] = outputfile[0];
                        if (system[index] === undefined)
                            system[index] = system[0];
                        fileArray.push({ inputfile: file, outputfile: outputfile[index], system: system[index] });
                    });
                });
                fileArray.forEach((file) => {
                    return this.requestfileposter('../print/PDFSrv', file.inputfile, file.system).then((res) => {
                        let resType = res.getResponseHeader('Content-Type');
                        let blob = res.response;
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = file.outputfile;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        this.dataIsReady = true;
                    });
                });
            }
            else if (data.webresponse.startsWith('#close#')) {
                this.lastResult = 'close';
                this.closeEvent = 'child#allflds';
                this.handleModalClose(true);
                this.clearAllProps();
            }
            else if (data.webresponse.startsWith('#pullback#')) {
                this.lastResult = 'pullback';
                let resArr = data.webresponse.split('#');
                this.handlePullBack(resArr[2], resArr[3], resArr[4]);
            }
            else if (data.webresponse.startsWith('#loadpage#')) {
                this.lastResult = 'loadpage';
                let resArr = data.webresponse.split('#');
                let lpParms = JSON.parse(unescape(resArr[2]));
                loadPage(lpParms.path, (_r = lpParms.parm) !== null && _r !== void 0 ? _r : '', { closeEvent: (_s = lpParms.closeEvent) !== null && _s !== void 0 ? _s : undefined, isNew: PIC.getInstance.webVersion == '3', parentSessId: this.selfSessId });
            }
            else if (data.webresponse.startsWith('#cmd#')) {
                this.lastResult = 'command';
                let responseArr = data.webresponse.split('#');
                if (responseArr.length > 3) {
                    fetchFormData.doErrorMsg("", 'error');
                    return;
                }
                try {
                    let commands = null;
                    //try parsing both as base64encoded and plain text, for legacy reasons
                    try {
                        let decoded = atob(responseArr[2]);
                        commands = objectDecoder(decoded);
                    }
                    catch (e) {
                        try {
                            commands = objectDecoder(responseArr[2]);
                        }
                        catch (e2) {
                            try {
                                commands = JSON.parse(atob(responseArr[2]));
                            }
                            catch (e3) {
                                Util.clearLoadingScreen();
                                fetchFormData.doErrorMsg("", 'error');
                                console.error('Failed to parse command object', responseArr[2]);
                                return;
                            }
                        }
                    }
                    window.allowSubmit = true; //legacy;
                    Util.clearLoadingScreen();
                    if (commands)
                        commands.commands.forEach(cmd => {
                            if (cmd.cmd == 'picaction' && cmd.action) {
                                let a = new PICAction();
                                a.actionOptions = cmd.action;
                                a.triggerEvent();
                            }
                        });
                }
                catch (e) {
                    Util.clearLoadingScreen();
                    fetchFormData.doErrorMsg('', 'error');
                }
            }
            else if (data.webresponse.startsWith('#fragment')) {
                window.modalIsLoading = false;
                this.preventRender = false;
                if (!data) {
                    this.dataIsReady = false;
                    this.isVisible = false;
                    let modal = this.slotParent;
                    modal === null || modal === void 0 ? void 0 : modal.closeModal(false);
                    this.clearAllProps();
                }
                let responseArr = data.webresponse.split('#');
                let fragtmentId = responseArr[2];
                let fragtmentHTML = responseArr[3];
                if (!fragtmentId)
                    return;
                let fragmentContainer = PIC.getInstance.findElementByIdDeep(fragtmentId);
                if (!fragmentContainer || !fragmentContainer.classList.contains('fragment-container'))
                    return;
                while (fragmentContainer.firstElementChild)
                    fragmentContainer.firstElementChild.remove();
                fragmentContainer.innerHTML = fragtmentHTML;
                Util.clearLoadingScreen();
            }
            else if (data.webresponse.startsWith('#') && !(data.webresponse.startsWith('#Open') || data.webresponse.startsWith('#open'))) {
                this.lastResult = 'message';
                /* handle showMessage / show error */
                /* TODO exclude other # events */
                this.preventRender = true;
                let choiceObj;
                try {
                    choiceObj = JSON.parse(data.webresponse.substring(1));
                }
                catch (error) {
                    choiceObj = {
                        choiceTitle: data.webresponse.substring(1),
                        isNew: PIC.getInstance.webVersion == '3',
                        choices: [
                            { choiceText: 'Ok', choiceEvent: '' }
                        ]
                    };
                }
                let modalWindow = new PICModal();
                this.shadowRoot.appendChild(modalWindow);
                if (modalWindow) {
                    modalWindow.isDialog = true;
                    modalWindow.height = 'unset';
                    modalWindow.modalBody = this.renderChoiceBox(modalWindow, choiceObj);
                    modalWindow.isHidden = false;
                    modalWindow.openModal();
                    this.isVisible = true;
                    this.dataIsReady = true;
                    this.requestUpdate();
                }
            }
            else {
                this.lastResult = 'DOMupdate';
                this.htmlDoc = parser.parseFromString(data.webresponse, 'text/html');
                this.dataIsReady = true;
                __classPrivateFieldSet(this, _PICLoadPage_modalBody, this.htmlDoc.querySelector('body'), "f");
                if (!this.isNew) {
                    if (this.htmlDoc.querySelector('#isUploadModal')) {
                        this.isOldUploadModal = true;
                    }
                    this.modalHeader = this.htmlDoc.querySelector('.pic-modalheader');
                    __classPrivateFieldSet(this, _PICLoadPage_modalFooter, this.htmlDoc.querySelector('.pic-modalfooter'), "f");
                    (_t = this.modalHeader) === null || _t === void 0 ? void 0 : _t.remove();
                    (_u = __classPrivateFieldGet(this, _PICLoadPage_modalFooter, "f")) === null || _u === void 0 ? void 0 : _u.remove();
                }
                else {
                    this.modalHeader = this.htmlDoc.querySelector('.pic-modalheader');
                    (_v = this.modalHeader) === null || _v === void 0 ? void 0 : _v.remove();
                    __classPrivateFieldSet(this, _PICLoadPage_modalFooter, this.htmlDoc.querySelectorAll('body pic-button:not([ModalBodyBtn="true"])'), "f");
                }
            }
        }).catch((e) => {
            if (this.isNew) {
                this.isVisible = true;
                this.dataIsReady = true;
                this.hasError = true;
                this.loadError = e;
            }
            else {
                this.dataIsReady = false;
                this.isVisible = false;
                let modal = this.slotParent;
                modal === null || modal === void 0 ? void 0 : modal.closeModal(false);
                this.clearAllProps();
            }
        });
    }
    addEvtListener(eventType, eventFunction, iOption) {
        this.listeners.set(eventType + ',' + eventFunction.name + guid(), {
            eventType: eventType,
            eventFunction: eventFunction,
        });
        window.tmpPrevent = false;
        this.addEventListener(eventType, eventFunction, iOption);
        function guid() {
            function _p8(s) {
                var p = (Math.random().toString(16) + "000000000").substr(2, 8);
                return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
            }
            return _p8() + _p8(true) + _p8(true) + _p8();
        }
    }
    addEvtOnce(eventType, eventFunction, iOption) {
        let ref = this;
        let wrappedFunc = function (e) {
            eventFunction(e);
            window.removeEventListener(eventType, wrappedFunc, iOption);
            ref.listeners.delete(eventType + ',' + eventFunction.name);
        };
        this.listeners.set(eventType + ',' + eventFunction.name, {
            eventType: eventType,
            eventFunction: eventFunction,
        });
        window.addEventListener(eventType, wrappedFunc, iOption);
    }
    clearEventListeners() {
        this.listeners.forEach((listener) => {
            if (listener.eventType != 'error')
                this.removeEventListener(listener.eventType, listener.eventFunction);
        });
    }
    setTimeout(eventFunction, timeout) {
        this.timeouts.push(window.setTimeout(eventFunction, timeout));
        return this.timeouts.length - 1;
    }
    clearTimeouts() {
        this.timeouts.forEach((timeout, idx) => {
            if (typeof timeout !== 'number')
                return;
            window.clearTimeout(timeout);
            this.timeouts[idx] = -1;
        });
        this.timeouts = this.timeouts.filter(timeout => timeout !== -1);
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.timeouts = [];
        this.PIC = {
            findElementByIdDeep: PIC.getInstance.findElementByIdDeep.bind(this),
            addEventListener: this.addEvtListener.bind(this),
            addEventOnce: this.addEvtOnce.bind(this),
            setTimeout: this.setTimeout.bind(this),
            isMac: PIC.getInstance.isMac,
            ctrlKeyIsDown: PIC.getInstance.ctrlKeyIsDown,
            user: PIC.getInstance.user,
            subwin: {},
            webmenu: {},
            findElement: undefined,
            sessionCode: this.selfSessId,
            systemId: (_a = this.systemId) !== null && _a !== void 0 ? _a : PIC.systemId
        };
        this.loadpageBroadcastChannel.addEventListener("message", (e) => {
            let iObj = e.data;
            if (iObj.command === 'DELETE' && this.parentSessId === iObj.sessionId) {
                // console.log('i:', this.selfSessId, 'am now an orphan, commiting seppuku');
                if (this.modal)
                    this.modal.removeKeyListener();
                this.removeSelf();
            }
            else if (iObj.command === 'DISABLE' && this.selfSessId === iObj.sessionId) {
                // console.log('I have been told to disable', this.selfSessId);
                if (this.modal)
                    this.modal.removeKeyListener();
                __classPrivateFieldSet(this, _PICLoadPage_isDisabled, true, "f");
                this.lastResult = 'enable/disable';
                this.requestUpdate();
            }
            else if (iObj.command === 'ENABLE' && this.selfSessId === iObj.sessionId) {
                // console.log('I have been told to enable', this.selfSessId);
                if (this.modal)
                    this.modal.addKeyListener();
                __classPrivateFieldSet(this, _PICLoadPage_isDisabled, false, "f");
                this.lastResult = 'enable/disable';
                this.requestUpdate();
            }
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.clearTimeouts();
        this.clearEventListeners();
        let msg = { command: 'DELETE', sessionId: this.selfSessId };
        this.loadpageBroadcastChannel.postMessage(msg);
        msg = { command: 'ENABLE', sessionId: this.parentSessId };
        this.loadpageBroadcastChannel.postMessage(msg);
    }
    loginTest() {
        var _a, _b, _c;
        let loginTest = (_c = (_b = (_a = __classPrivateFieldGet(this, _PICLoadPage_modalBody, "f")) === null || _a === void 0 ? void 0 : _a.querySelector('input[name=Subwin]')) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '';
        if (loginTest === 'util/logon')
            doSubmit('#exit');
        return loginTest === 'util/logon';
    }
    handleLoad() {
        this.requestUpdate();
        if (this.isFirstLoad) {
            // console.log('First load?', this)
            this.refreshPostBody();
            Util.setLoadingScreen();
            this.getDataFromApi().then(() => {
                this.lastResult = 'handleLoad';
                this.requestUpdate();
            }).then(() => {
                if (this.loginTest()) {
                }
                else {
                    this.isVisible = true;
                    this.requestUpdate();
                    let modal = this.slotParent;
                    if (modal) {
                        modal.openModal();
                    }
                }
            })
                .finally(() => {
                var _a, _b;
                Util.clearLoadingScreen();
                const immediateEvent = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('input[name=__immediateevent__]');
                if (immediateEvent instanceof HTMLInputElement && ((_b = immediateEvent.value) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    this.setTimeout(() => this.handleSubmit(immediateEvent.value, null), 0);
                }
            });
            this.isFirstLoad = false;
            this.dataIsReady = false;
        }
    }
    isPreventable(prevenableList, eventId) {
        var _a;
        if ((_a = prevenableList === null || prevenableList === void 0 ? void 0 : prevenableList.getAttribute('eventlst')) === null || _a === void 0 ? void 0 : _a.includes(eventId))
            return true;
        else
            return false;
    }
    getStyleSheet() {
        let url = window.location.href.split('/');
        return url[url.length - 1];
    }
    getPICInputFields(node, PICFieldList) {
        var _a;
        if (node) {
            if (node instanceof PICInput || node instanceof PICWebTable || node instanceof PICDualSelector) {
                PICFieldList.push(node);
            }
            if (node instanceof PICTab) {
                this.getPICInputFields((_a = node.shadowRoot) === null || _a === void 0 ? void 0 : _a.getRootNode(), PICFieldList);
            }
            this.getPICInputFields(node.firstElementChild, PICFieldList);
            this.getPICInputFields(node.nextSibling, PICFieldList);
        }
        else
            return;
    }
    deSerializeStr(iStr, iFieldSep, iElementSep) {
        let strArr = iStr.split(iElementSep);
        let outObj = {};
        for (let i = 0; i < strArr.length; i++) {
            let curField = strArr[i].split(iFieldSep);
            if (curField && curField.length > 1)
                outObj[curField[0]] = curField[1];
        }
        return outObj;
    }
    renderChoiceButton(modalWindow, c, disabled) {
        var _a;
        let event = (_a = c.event) !== null && _a !== void 0 ? _a : c.choiceEvent;
        let text = c.choiceText;
        let focus = c.chooseBtnFocus;
        try {
            let parmObj = this.deSerializeStr(c.parms, '=', ',');
            if (parmObj) {
                if (parmObj.closeEvent)
                    event = parmObj.closeEvent;
                if (parmObj.choiceText)
                    text = parmObj.choiceText;
                if (parmObj.chooseBtnFocus)
                    focus = parmObj.chooseBtnFocus;
            }
            return html `
            <button 
                class="button choice-button" 
                data-event="${event}" 
                data-focus="${focus}"
                @click=${() => {
                this.closeEvent = event;
                this.handleModalClose(true);
            }}  
                ?disabled=${disabled}> ${text} 
            </button>
        `;
        }
        catch (_b) {
            return html `
            <button 
            class="button choice-button" 
            data-event="${event}" 
            data-focus="${focus}"
            @click=${() => this.handleClickSubmit(modalWindow, event)}  
            ?disabled=${disabled}> ${text}
         </button>
            `;
        }
    }
    renderChoiceBox(modalWindow, iData) {
        var _a;
        let titleArr = iData.choiceTitle.split('\n'); // prevent newlines from getting ignored
        if (!this.isNew)
            this.preventRender = false;
        return html `
            <div class="container-title">
                ${titleArr.map((t) => renderChoiceTitle(t))}
            </div>
            <div class="container-choice">
                ${(_a = iData.choices) === null || _a === void 0 ? void 0 : _a.map((c) => this.renderChoiceButton(modalWindow, c, false))}
            </div>
        `;
        function renderChoiceTitle(iT) {
            return html `
                <h1 class=${PIC.getInstance.webVersion == '3' ? 'pic-h6' : ''}>${iT}</h1>
            `;
        }
    }
    handleClickSubmit(modalWindow, iStr) {
        modalWindow.isHidden = true;
        modalWindow.closeModal(false);
        if (iStr && typeof iStr != 'object' && iStr.length > 0) {
            this.lastResult = 'handleClickSubmit';
            this.handleSubmit(iStr, null);
        }
        modalWindow.remove();
    }
    handlePullBack(parentElm, editParm, dispParm) {
        var _a, _b, _c;
        let tmpElmEdit = PIC.getInstance.findElementByIdDeep(parentElm);
        let tmpElmDisp = PIC.getInstance.findElementByIdDeep(parentElm + 'disp');
        if (tmpElmDisp)
            tmpElmDisp.value = dispParm;
        if (tmpElmEdit)
            tmpElmEdit.inputField.dispatchEvent(new CustomEvent('pullback', { detail: { value: editParm } }));
        if (this.isNew) {
            //new
            this.dataIsReady = false;
            this.isVisible = false;
            this.closeEvent = '';
            if (tmpElmEdit)
                PIC.getInstance.setTimeout(() => tmpElmEdit.focusHandler('in'), 50);
            if (tmpElmDisp)
                PIC.getInstance.setTimeout(() => tmpElmDisp.requestUpdate(), 50);
            this.handleModalClose(true);
        }
        else {
            //old   
            this.dataIsReady = false;
            this.isVisible = false;
            let modal = this.slotParent;
            modal === null || modal === void 0 ? void 0 : modal.closeModal(false);
            this.clearAllProps();
        }
        //ensure interaction blocker gets removed
        if ((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.blocker'))
            (_c = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.blocker')) === null || _c === void 0 ? void 0 : _c.remove();
    }
    //Modal submit handler
    handleSubmit(iStr, iObj) {
        if (this.submitInProgress)
            return;
        this.submitInProgress = true;
        if (iObj) {
            iObj = iObj;
            if (iObj.choiceBox.isDefaultBox) {
                let defChoiceElm = document.querySelector('input[name="__defaultchoice"]');
                if (defChoiceElm && defChoiceElm.hasAttribute('choiceTitle')) {
                    iObj.choiceTitle = defChoiceElm.getAttribute('choiceTitle');
                    iObj.choices = [
                        { choiceText: defChoiceElm.getAttribute('choicetrue'), choiceEvent: iStr },
                        { choiceText: defChoiceElm.getAttribute('choicefalse'), choiceEvent: '' }
                    ];
                }
                else {
                    iObj.choiceTitle = 'Are you sure?';
                    iObj.choices = [
                        { choiceText: 'Yes', choiceEvent: iStr },
                        { choiceText: 'No', choiceEvent: '' }
                    ];
                }
            }
            else if (iObj["choiceBox"]) {
                iObj = iObj.choiceBox.customBox;
            }
            let modalWindow = new PICModal();
            this.shadowRoot.appendChild(modalWindow);
            if (modalWindow) {
                modalWindow.isDialog = true;
                modalWindow.height = 'unset';
                modalWindow.modalBody = this.renderChoiceBox(modalWindow, iObj);
                modalWindow.isHidden = false;
                modalWindow.openModal();
            }
            this.submitInProgress = false;
            return;
        }
        this.clearTimeouts();
        this.clearEventListeners();
        Util.setLoadingScreen();
        this.getDataFromApi(iStr, undefined, true).then(() => {
            this.submitInProgress = false;
            if (this.loginTest()) {
            }
            else {
                this.isVisible = true;
                this.requestUpdate();
                let modal = this.slotParent;
                if (modal)
                    modal.openModal();
            }
        }).catch(() => {
            this.submitInProgress = false;
        }).finally(() => {
            Util.clearLoadingScreen();
        });
    }
    updated() {
        var _a;
        let elements = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll("textarea");
        if (elements)
            for (var i = 0; i < elements.length; i++) {
                if (elements[i].value == "-- --")
                    elements[i].value = "";
            }
        this.handleSubWinOnLoad();
    }
    handleSubWinOnLoad() {
        let event = new CustomEvent('subWinOnLoadReplacment', {
            detail: { load: true }, bubbles: true, composed: true,
        });
        if (!this.isNew) {
            this.focusHandler();
        }
        window.dispatchEvent(event);
    }
    getLoadpageHeaderClass() {
        return {
            'pic-loadingblank': !this.dataIsReady || __classPrivateFieldGet(this, _PICLoadPage_isDisabled, "f"),
            'pic-loadpageheader': true && !this.isNew,
            'justify-center': this.headermode === 'center',
            'justify-start': this.headermode === 'left',
            'justify-end': this.headermode === 'right',
            'oldHeader': this.isNew === false
        };
    }
    getLoadpageBodyClass() {
        return {
            'pic-loadingicon': !this.dataIsReady,
            'pic-loadingblank': __classPrivateFieldGet(this, _PICLoadPage_isDisabled, "f"),
            'pic-loadpagebody': true && !this.isNew,
            'loadPageBody': true
        };
    }
    getLoadpageFooterClass() {
        return {
            'pic-loadingblank': !this.dataIsReady || __classPrivateFieldGet(this, _PICLoadPage_isDisabled, "f"),
            'pic-loadpagefooter': true && !this.isNew,
            'pic-loadpagefooterbtn': this.isNew,
            'justify-center': this.footermode === 'center',
            'justify-start': this.footermode === 'left',
            'justify-end': this.footermode === 'right',
            'oldFooter': this.isNew === false
        };
    }
    focusHandler() {
        if (this.shadowRoot) {
            let bodyelm = this.shadowRoot.querySelector('.pic-loadpagebody');
            if (bodyelm) {
                let lpRef = this;
                function raceconditionfix() {
                    let firstElm, lastElm, elmLst = bodyelm === null || bodyelm === void 0 ? void 0 : bodyelm.querySelectorAll('[piccomponent]:not([disabled]), input[type="button"]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
                    if (elmLst) {
                        if (elmLst.length > 0) {
                            firstElm = elmLst[0];
                            lastElm = elmLst[elmLst.length - 1];
                            PIC.getInstance.events.setActiveModalFocusElements(lpRef, firstElm, lastElm);
                        }
                    }
                }
                /* this has to be in a 1ms settimeout */
                setTimeout(raceconditionfix, 1);
            }
        }
    }
    getFirefoxSafeHeight() {
        var _a, _b, _c, _d;
        const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        if (isFirefox) {
            const viewportHeight = window.innerHeight;
            const headerHeight = ((_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.pic-loadpageheader')) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
            const footerHeight = ((_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.pic-loadpagefooter')) === null || _d === void 0 ? void 0 : _d.offsetHeight) || 0;
            console.log('headerHeight, footerHeight', headerHeight, footerHeight);
            const availableHeight = viewportHeight - headerHeight - footerHeight - 32;
            return `${Math.max(availableHeight * 0.7, 300)}px`;
        }
        return '80vh';
    }
    renderOld() {
        let ILS = directive(InlineScriptDirective);
        let modal = this.slotParent;
        if (modal) {
            modal.hasPadding = false;
            modal.preventCloseRender = this.isOldUploadModal;
            setTimeout(() => { modal.requestUpdate(); }, 1);
        }
        const loadpageBodyStyle = {
            'overflow-y': 'auto',
            'max-height': this.getFirefoxSafeHeight(),
        };
        return html `
            <div class="pic-loadpage" .dom=${this}>
                <div class=${classMap(this.getLoadpageHeaderClass())}>
                    ${this.modalHeader}
                </div>
                <div class=${classMap(this.getLoadpageBodyClass())} style=${styleMap(loadpageBodyStyle)}>
                    ${ILS(this.htmlDoc.documentElement)}
                </div>
                <div class=${classMap(this.getLoadpageFooterClass())}>
                    ${__classPrivateFieldGet(this, _PICLoadPage_modalFooter, "f")}
                </div>
            </div>
        `;
    }
    removeSelf() {
        var _a;
        let child = this.selfSessId ? PIC.getInstance.PICWinMap.get(this.selfSessId) : undefined;
        if (this.selfSessId)
            PIC.getInstance.PICWinMap.delete(this.selfSessId);
        if (child) {
            let parent = child.parentElement;
            parent === null || parent === void 0 ? void 0 : parent.removeChild(child);
            // If render old then remove the outer modal also
            if ((parent === null || parent === void 0 ? void 0 : parent.nodeName) === 'PIC-MODAL')
                (_a = parent.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(parent);
        }
        this.clearAllProps();
    }
    handleModalClose(iconClick) {
        var _a, _b, _c, _d, _e;
        this.isVisible = false;
        let settingsElm = this.htmlDoc.querySelector(`#__modalsettings__`);
        if (settingsElm && !__classPrivateFieldGet(this, _PICLoadPage_settingsReadAlready, "f")) {
            this.settingsObj = objectDecoder(settingsElm === null || settingsElm === void 0 ? void 0 : settingsElm.value);
        }
        if ((_a = this.settingsObj) === null || _a === void 0 ? void 0 : _a.closeEvent)
            this.closeEvent = (_b = this.settingsObj) === null || _b === void 0 ? void 0 : _b.closeEvent;
        if (this.closeEvent && iconClick && !this.hasError) {
            if (this.parentSessId && PIC.getInstance.PICWinMap.has(this.parentSessId)) {
                let parent = PIC.getInstance.PICWinMap.get(this.parentSessId);
                let child = this.selfSessId ? PIC.getInstance.PICWinMap.get(this.selfSessId) : undefined;
                if ((parent === null || parent === void 0 ? void 0 : parent.nodeName) === 'HTML') {
                    doSubmit(this.closeEvent);
                    this.removeSelf();
                }
                else if ((parent === null || parent === void 0 ? void 0 : parent.nodeName) === 'PIC-LOADPAGE') {
                    parent.handleSubmit(this.closeEvent, null);
                    this.isClosed = true;
                    this.removeSelf();
                }
            }
            else {
                this.removeSelf();
                doSubmit(this.closeEvent);
            }
        }
        //ensure interaction blocker gets removed
        if ((_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.blocker'))
            (_e = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('.blocker')) === null || _e === void 0 ? void 0 : _e.remove();
        //kill elements
        if (!this.closeEvent && iconClick) {
            this.isClosed = true;
            this.removeSelf();
        }
        this.clearAllProps();
    }
    renderNew() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
        if (this.modal)
            this.modal.isHidden = !this.isVisible;
        if (this.lastResult !== 'enable/disable') {
            let cssElmCandidates = (_a = this.htmlDoc.querySelector('head')) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('link');
            __classPrivateFieldSet(this, _PICLoadPage_cssElms, [], "f");
            if (cssElmCandidates)
                for (let link of cssElmCandidates) {
                    if ((_b = link.getAttribute('href')) === null || _b === void 0 ? void 0 : _b.startsWith('/css')) {
                        __classPrivateFieldGet(this, _PICLoadPage_cssElms, "f").push(link);
                        this.cssStrings.push(link.getAttribute('href'));
                    }
                }
            (_c = this.htmlDoc.querySelector('.pic-header')) === null || _c === void 0 ? void 0 : _c.remove();
            (_d = this.htmlDoc.querySelector('.pic-footer')) === null || _d === void 0 ? void 0 : _d.remove();
            //let settingsObj: PICModalSettings | null = null, settingsElm = this.htmlDoc.querySelector(`#${this.apiurl.replace(/\//g, '')}__modalsettings__`);
            let settingsElm = this.htmlDoc.querySelector(`#__modalsettings__`);
            if (settingsElm && !__classPrivateFieldGet(this, _PICLoadPage_settingsReadAlready, "f")) {
                this.settingsObj = objectDecoder(settingsElm === null || settingsElm === void 0 ? void 0 : settingsElm.value);
                this.headermode = (_e = this.settingsObj) === null || _e === void 0 ? void 0 : _e.headerMode;
                this.footermode = (_f = this.settingsObj) === null || _f === void 0 ? void 0 : _f.footerMode;
                if ((_g = this.settingsObj) === null || _g === void 0 ? void 0 : _g.disableNav)
                    this.disableNav = (_h = this.settingsObj) === null || _h === void 0 ? void 0 : _h.disableNav;
                if ((_j = this.settingsObj) === null || _j === void 0 ? void 0 : _j.centerOnParent)
                    this.centerOnParent = (_k = this.settingsObj) === null || _k === void 0 ? void 0 : _k.centerOnParent;
                if ((_l = this.settingsObj) === null || _l === void 0 ? void 0 : _l.keepSize)
                    this.keepSize = (_m = this.settingsObj) === null || _m === void 0 ? void 0 : _m.keepSize;
                if (((_o = this.settingsObj) === null || _o === void 0 ? void 0 : _o.allowResize) === false)
                    this.allowResize = (_p = this.settingsObj) === null || _p === void 0 ? void 0 : _p.allowResize;
                if ((_q = this.settingsObj) === null || _q === void 0 ? void 0 : _q.width)
                    this.width = (_r = this.settingsObj) === null || _r === void 0 ? void 0 : _r.width;
                if ((_s = this.settingsObj) === null || _s === void 0 ? void 0 : _s.height)
                    this.height = (_t = this.settingsObj) === null || _t === void 0 ? void 0 : _t.height;
                if ((_u = this.settingsObj) === null || _u === void 0 ? void 0 : _u.customChoiceBox) {
                    this.settingsObj.customChoiceBox['choiceBox'] = { hasChoiceBox: false, isDefaultBox: false, customBox: this.settingsObj.customChoiceBox };
                    this.customChoiceBox = this.settingsObj.customChoiceBox;
                }
                if (((_v = this.settingsObj) === null || _v === void 0 ? void 0 : _v.closeEvent) && ((_w = this.settingsObj) === null || _w === void 0 ? void 0 : _w.overrideCloseEvent)) {
                    this.closeEvent = this.settingsObj.closeEvent;
                    this.overrideCloseEvent = true;
                    delete this.settingsObj.closeEvent;
                    delete this.settingsObj.overrideCloseEvent;
                }
                __classPrivateFieldSet(this, _PICLoadPage_settingsReadAlready, true, "f");
            }
            else {
                this.settingsObj = {};
            }
        }
        else {
            // i have already run and had settings done on me, keep user interacted settings instead
            if (__classPrivateFieldGet(this, _PICLoadPage_settingsReadAlready, "f")) {
                this.settingsObj = {};
            }
        }
        let drawHeader = true;
        if (this.modalHeader) {
            if (this.headermode === 'hidden') {
                drawHeader = false;
            }
        }
        let drawFooter = true;
        if (__classPrivateFieldGet(this, _PICLoadPage_modalFooter, "f")) {
            if (this.footermode === 'hidden') {
                drawFooter = false;
            }
            else if (__classPrivateFieldGet(this, _PICLoadPage_modalFooter, "f") instanceof HTMLElement) {
            }
            else {
                try {
                    if (__classPrivateFieldGet(this, _PICLoadPage_modalFooter, "f").length === 0)
                        drawFooter = false;
                }
                catch (_7) {
                }
            }
        }
        return html `
            <pic-modal 
                .isNew=${true} 
                .isHidden=${!this.isVisible} 
                .parent=${this} 
                .title_=${((_x = this.modalHeader) === null || _x === void 0 ? void 0 : _x.innerHTML) ? (_y = this.modalHeader) === null || _y === void 0 ? void 0 : _y.innerHTML : ''} 
                .width=${(_z = this.width) !== null && _z !== void 0 ? _z : ''} 
                .height=${(_0 = this.height) !== null && _0 !== void 0 ? _0 : ''}
                .top=${(_2 = (_1 = this.settingsObj) === null || _1 === void 0 ? void 0 : _1.top) !== null && _2 !== void 0 ? _2 : ''}
                .left=${(_4 = (_3 = this.settingsObj) === null || _3 === void 0 ? void 0 : _3.left) !== null && _4 !== void 0 ? _4 : ''}
                .allowResize=${this.allowResize}
                .disableNav=${this.disableNav}
                .centerOnParent=${this.centerOnParent}
                .keepSize=${this.keepSize}
                .startCentered=${(_6 = (_5 = this.settingsObj) === null || _5 === void 0 ? void 0 : _5.startCentered) !== null && _6 !== void 0 ? _6 : true}
                .drawHeader=${drawHeader}
                .drawFooter=${drawFooter}
                .drawMode=${this.drawMode}
                .parentFieldStr=${this.parentFieldStr}
                class=${this.params === 'commInfo' ? 'commInfo' : ''}
                >
                <div slot="slot-modal-header" class=${classMap(this.getLoadpageHeaderClass())}>
                    ${html `${__classPrivateFieldGet(this, _PICLoadPage_cssElms, "f")}`}
                    ${__classPrivateFieldGet(this, _PICLoadPage_cssElms, "f").find(x => { var _a; return (_a = x.getAttribute('href')) === null || _a === void 0 ? void 0 : _a.includes('webtoolbox'); }) ? '' : this.cssStrings.map(css => { return html `<link rel="stylesheet" href=${css}>`; })}
                </div>
                <div slot="slot-modal-body" class=${classMap(this.getLoadpageBodyClass())}>
                    ${__classPrivateFieldGet(this, _PICLoadPage_modalBody, "f")}
                </div>
                ${drawFooter ? html `
                <div slot="slot-modal-footer" class=${classMap(this.getLoadpageFooterClass())}>
                    <div class="loadPage-footer">
                        ${__classPrivateFieldGet(this, _PICLoadPage_modalFooter, "f")}
                    </div>
                </div>`
            : ''}
                
            </pic-modal>
        `;
    }
    renderEmpty() {
        this.isClosed = false;
        return nothing;
    }
    renderError() {
        let modalHdr = 'Error';
        let modalFooter = '';
        return html `
            <pic-modal 
                .isNew=${PIC.getInstance.webVersion == '3'} 
                .parent=${this} 
                .isHidden=${!this.isVisible} 
                .title_=${modalHdr}>
                <div slot="slot-modal-body" class=${classMap(this.getLoadpageBodyClass())}>
                    <p class="pic-h1" style="color: var(--pic-statusErrorColor)">${this.loadError == 'Modal is already loading' ? 'Loading data, please wait.' : 'API fetch has failed. Please close and retry.'}</p>
                </div>
                <div slot="slot-modal-footer" class=${classMap(this.getLoadpageFooterClass())}>
                    ${modalFooter}
                </div>
            </pic-modal>
        `;
    }
    render() {
        if (this.isNew) {
            if (this.hasError)
                return this.renderError();
            else if (this.isClosed)
                return this.renderEmpty();
            else
                return this.renderNew();
        }
        else
            return this.renderOld();
    }
};
_PICLoadPage_modalFooter = new WeakMap();
_PICLoadPage_isDisabled = new WeakMap();
_PICLoadPage_modalBody = new WeakMap();
_PICLoadPage_cssElms = new WeakMap();
_PICLoadPage_settingsReadAlready = new WeakMap();
PICLoadPage.styles = css `
        .modal {
            max-width: unset;
            padding: 0;
        }
        .pic-loadpage {
            height: -webkit-fill-available;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .pic-loadpageheader {
            background-color: var(--headerColor, var(--pic-tableMediumBgColor, #ffff));
            left: unset;
            right: unset;
            top: unset;
            margin: 0px;
            padding: 10px;
            color: white;
            position: unset;
            height: var(--headerHeight);
        }
        .oldHeader {
            position: sticky;
            top: 0; 
            left: 0;
            width: 100%;
            z-index: 1;
        }
        .oldFooter {
            position: sticky !important;
            bottom: 0; 
            left: 0;
            width: 100%;
            z-index: 1;
        }
        .pic-loadpagebody {
            background-color: var(--defaultBgColor, var(--pic-backgroundColor, #ffff));
            flex-grow: 1;
            padding-top: 0.5rem;
        }
        .pic-mainbody {
            padding: 0 !important;
        }
        .pic-loadpagebody .page {
            left: unset;
            right: unset;
            top: unset;
            position: unset;
            width: 98%;
            padding-bottom: unset;
        }
        .oldHeader .pic-loadpagebody {
            overflow: auto;
        }
        .oldHeader .page {
            top: revert-layer;
        }
        .oldHeader::-webkit-scrollbar {
            width: 5px;
        }
        .oldHeader::-webkit-scrollbar-track {
            width: 5px;
        }
        .pic-loadpagefooter {
            background-color: var(--headerColor, var(--pic-tableMediumBgColor, #ffff));
            position: unset;
        }
        .pic-loadpagefooter .button {
            background-color: var(--headerColor, var(--pic-tableMediumBgColor, #ffff));
        }
        .pic-svgloadicon svg {
            height: inherit;
            justify-content: center;
            align-items: center;
        }

        .pic-loadinghidden {
            display: none;
        }

        .pic-loadingicon {
            background-color: var(--defaultBgColor, var(--pic-backgroundColor, #ffff));
            pointer-events: none;
            opacity: 0.4;
            background-image: url(data:image/gif;base64,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);
            background-repeat: no-repeat;
            background-position-x: center;
            background-position-y: center;
        }

        .pic-loadingblank {
            pointer-events: none;
            opacity: 0.4;
        }

        .pic-loadpagefooterbtn {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            gap: 5px;
            /* padding-bottom: 4px; */
            width: fit-content;
            /* height: 100%; */
        }
        .hidden {
            display: none;
        }
        .justify-start {
            justify-content: flex-start;
        }
        .justify-center {
            justify-content: center;
        }
        .justify-end {
            justify-content: flex-end;
        }   
        .pic-loadpagefooter tr {
            text-align: center;
        }

        .pic-loadpagefooter td input.button{
            max-width: 400px;
        }
        .loadPage-footer {
            display: flex;
            overflow: auto;
            gap: 14px;
            width: fit-content;
            min-height: 42px;
            align-items: center;
            padding-top: 2px;
        }        
        .blocker{
            width: 100%;
            height: 100%;
            z-index: 20;
            background-color: #9b9b9b80;
            position: fixed;
            bottom: 0;
            left: 0;
        }
  `;
__decorate([
    property({ converter: stringDecoder })
], PICLoadPage.prototype, "header", void 0);
__decorate([
    property()
], PICLoadPage.prototype, "apiurl", void 0);
__decorate([
    property()
], PICLoadPage.prototype, "params", void 0);
__decorate([
    property({ converter: stringDecoder, reflect: true })
], PICLoadPage.prototype, "closeEvent", void 0);
__decorate([
    property({ attribute: 'system', converter: (value) => { if (value && value.length > 0 && value !== '?')
            return value; return undefined; } })
], PICLoadPage.prototype, "systemId", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICLoadPage.prototype, "isNew", void 0);
__decorate([
    query('pic-modal')
], PICLoadPage.prototype, "modal", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICLoadPage.prototype, "headermode", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICLoadPage.prototype, "footermode", void 0);
__decorate([
    property()
], PICLoadPage.prototype, "drawMode", void 0);
PICLoadPage = __decorate([
    customElement('pic-loadpage')
], PICLoadPage);
export { PICLoadPage };
//# sourceMappingURL=PICLoadPage.js.map